import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setAuthorization from '../utils/helpers/setAuthorization'
import { API_BASE_URL } from '../constants/api'

const liveClassRepository = createApi({
	reducerPath: 'liveClassRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['LiveClass', 'LiveClassByCohort'],
	endpoints: (builder) => ({
		get: builder.query<
			{
				aula_do_dia: Array<{
					id: number
					nome_aula: string
					is_today: boolean
					data_aula: string
					horario_inicio: string
					horario_fim: string
					link_aula: string
					memhack?: string
					material?: string
					usuario_id: number
				}>
				proximas_aulas: Array<{
					id: number
					nome_aula: string
					is_today: boolean
					data_aula: string
					horario_inicio: string
					horario_fim: string
					link_aula: string
					memhack?: string
					material?: string
					usuario_id: number
				}>
				aulas_realizadas: number
				total: number
			},
			{ userId: number }
		>({
			query: ({ userId }) => ({
				url: `/v1/cohorts/classes/student/${userId}`,
				method: 'GET',
			}),
			providesTags: ['LiveClass'],
		}),
		getByCohort: builder.query<
			{
				aula_do_dia: Array<{
					id: number
					nome_aula: string
					is_today: boolean
					data_aula: string
					horario_inicio: string
					horario_fim: string
					link_aula: string
					memhack?: string
					material?: string
					usuario_id: number
				}>
				proximas_aulas: Array<{
					id: number
					nome_aula: string
					is_today: boolean
					data_aula: string
					horario_inicio: string
					horario_fim: string
					link_aula: string
					memhack?: string
					material?: string
					usuario_id: number
				}>
				aulas_realizadas: number
				total: number
				nivel: string
				ciclo: string
				presenca: string
				progresso_por_nivel: string
			},
			{ userId: number; turmaId: number }
		>({
			query: ({ userId, turmaId }) => ({
				url: `/v1/cohorts/classes/student/${userId}/turma/${turmaId}`,
				method: 'GET',
			}),
			providesTags: ['LiveClassByCohort'],
		}),
		feedbackLiveClass: builder.mutation<
			void,
			{
				aula_id: number
				happened: boolean
				feedback?: string
				rating?: number
				tags?: string[]
			}
		>({
			query: ({ aula_id, ...body }) => ({
				url: `/v1/liveClass/${aula_id}/feedback`,
				method: 'POST',
				body: { aula_id, ...body },
			}),
			invalidatesTags: ['LiveClassByCohort'],
		}),
	}),
})

export default liveClassRepository
